import PaymentResult from './PaymentResult';
export default PaymentResult;
